// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"styles_tabsContainer__9SssH","mobileDropdown":"styles_mobileDropdown__1Lkxf"};